// // TO ACTIVE TO TEST LOCALLY
// import { initAccordion } from '../../accordion/js/global';

// (function () {
//   'use strict';

//   let locations = [
//     {
//       continent: 'Europe',
//       name: 'Bulgaria',
//       latitude: 42.6877560606604,
//       longitude: 23.316724059502977,
//       addressOne:
//         'Via Euganea 151/E, Appartamento n. 16, secondo piano, Selvazzano Dentro (Padova)',
//     },
//     {
//       continent: 'Europe',
//       name: 'Cyprus',
//       latitude: 35.17918477641823,
//       longitude: 33.38504032425337,
//       addressOne: '100 Market Street San Francisco, CA 94105 USA',
//     },
//     {
//       continent: 'Europe',
//       name: 'England',
//       latitude: 51.50117853368296,
//       longitude: -0.1187716882633571,
//       addressOne: '4 Fulham Broadway Hammersmith SW6 1BW',
//     },
//     {
//       continent: 'Europe',
//       name: 'Ireland',
//       latitude: 53.344383021752954,
//       longitude: -6.26836509195993,
//       addressOne: '100 Market Street San Francisco, CA 94105 USA',
//     },
//     {
//       continent: 'Europe',
//       name: 'Italy',
//       latitude: 45.40902718121571,
//       longitude: 11.876653730082413,
//       addressOne:
//         'Via Euganea 151/E, Appartamento n. 16, secondo piano, Selvazzano Dentro (Padova)',
//     },
//     {
//       continent: 'Europe',
//       name: 'Malta',
//       latitude: 35.8990954283288,
//       longitude: 14.484647804275268,
//       addressOne: '100 Market Street San Francisco, CA 94105 USA',
//     },
//     {
//       continent: 'Europe',
//       name: 'Switzerland',
//       latitude: 47.19935524925858,
//       longitude: 8.53560921925637,
//       addressOne:
//         'Via Euganea 151/E, Appartamento n. 16, secondo piano, Selvazzano Dentro (Padova)',
//     },
//     {
//       continent: 'Europe',
//       name: 'Ukraine',
//       latitude: 50.452661239087945,
//       longitude: 30.55671608275868,
//       addressOne:
//         'Via Euganea 151/E, Appartamento n. 16, secondo piano, Selvazzano Dentro (Padova)',
//     },
//     {
//       continent: 'Europe',
//       name: 'Wales',
//       latitude: 51.48971099968205,
//       longitude: -3.1808484952212983,
//       addressOne: '100 Market Street San Francisco, CA 94105 USA',
//     },
//     {
//       continent: 'Middle East',
//       name: 'Dubai',
//       latitude: 25.19901104143221,
//       longitude: 55.29064961346122,
//       addressOne:
//         'Via Euganea 151/E, Appartamento n. 16, secondo piano, Selvazzano Dentro (Padova)',
//     },
//     {
//       continent: 'Middle East',
//       name: 'Abu Dhabi',
//       latitude: 24.416130991301475,
//       longitude: 54.523591768383405,
//       addressOne: '100 Market Street San Francisco, CA 94105 USA',
//     },
//     {
//       continent: 'Middle East',
//       name: 'Bahrain',
//       latitude: 26.22700015509063,
//       longitude: 50.586159236619814,
//       addressOne:
//         'Via Euganea 151/E, Appartamento n. 16, secondo piano, Selvazzano Dentro (Padova)',
//     },
//     {
//       continent: 'Middle East',
//       name: 'Israel',
//       latitude: 31.774132572683484,
//       longitude: 35.21707213561021,
//       addressOne: '100 Market Street San Francisco, CA 94105 USA',
//     },
//     {
//       continent: 'Middle East',
//       name: 'Pakistan',
//       latitude: 31.541373372700612,
//       longitude: 74.34193318537444,
//       addressOne: '100 Market Street San Francisco, CA 94105 USA',
//     },
//     {
//       continent: 'Africa',
//       name: 'Kenya',
//       latitude: -1.2839864237237306,
//       longitude: 36.82782489175853,
//       addressOne:
//         'Via Euganea 151/E, Appartamento n. 16, secondo piano, Selvazzano Dentro (Padova)',
//     },
//     {
//       continent: 'Africa',
//       name: 'Tanzania',
//       latitude: -6.7815166327375,
//       longitude: 39.225106047164076,
//       addressOne: '100 Market Street San Francisco, CA 94105 USA',
//     },
//     {
//       continent: 'Africa',
//       name: 'Egypt',
//       latitude: 30.051458712361534,
//       longitude: 31.237521080210158,
//       addressOne:
//         'Via Euganea 151/E, Appartamento n. 16, secondo piano, Selvazzano Dentro (Padova)',
//     },
//     {
//       continent: 'Africa',
//       name: 'South Africa',
//       latitude: -25.957615804399985,
//       longitude: 28.147313965832755,
//       addressOne: '100 Market Street San Francisco, CA 94105 USA',
//     },
//     {
//       continent: 'Africa',
//       name: 'Namibia',
//       latitude: -22.557713523673673,
//       longitude: 17.068745196723846,
//       addressOne:
//         'Via Euganea 151/E, Appartamento n. 16, secondo piano, Selvazzano Dentro (Padova)',
//     },
//     {
//       continent: 'North America',
//       name: 'USA',
//       latitude: 42.26145412153812,
//       longitude: -71.46451593164139,
//       addressOne:
//         'Via Euganea 151/E, Appartamento n. 16, secondo piano, Selvazzano Dentro (Padova)',
//     },
//     {
//       continent: 'North America',
//       name: 'Canada',
//       latitude: 45.413677037471096,
//       longitude: -75.70344762654142,
//       addressOne: '',
//     },
//     {
//       continent: 'North America',
//       name: 'Cayman Islands',
//       latitude: 19.29535005013004,
//       longitude: -81.38157421797543,
//       addressOne: '',
//     },
//     {
//       continent: 'Latin America',
//       name: 'Argentina',
//       latitude: -34.59547090351832,
//       longitude: -58.42540251742731,
//       addressOne: '',
//     },
//     {
//       continent: 'Latin America',
//       name: 'Colombia',
//       latitude: 4.697566909343058,
//       longitude: -74.08858350802966,
//       addressOne: '',
//     },
//     {
//       continent: 'Latin America',
//       name: 'Brazil',
//       latitude: -23.463081580871876,
//       longitude: -46.87737299006655,
//       addressOne: '',
//     },
//     {
//       continent: 'Latin America',
//       name: 'Mexico',
//       latitude: 19.443491798838927,
//       longitude: -99.13751730821019,
//       addressOne: '',
//     },
//     {
//       continent: 'Latin America',
//       name: 'Chile',
//       latitude: -33.458931452269766,
//       longitude: -70.66279822499394,
//       addressOne: '',
//     },
//     {
//       continent: 'Latin America',
//       name: 'Panama',
//       latitude: 9.049197698682029,
//       longitude: -79.4854121603738,
//       addressOne: '',
//     },
//     {
//       continent: 'Latin America',
//       name: 'Peru',
//       latitude: -12.031290955906016,
//       longitude: -77.03722754088176,
//       addressOne: '',
//     },
//     {
//       continent: 'Asia',
//       name: 'Hong Kong',
//       latitude: 22.340573601074606,
//       longitude: 114.17026212550127,
//       addressOne: '',
//     },
//     {
//       continent: 'Asia',
//       name: 'Taiwan',
//       latitude: 25.04614002501038,
//       longitude: 121.53779609755655,
//       addressOne: '',
//     },
//     {
//       continent: 'Asia',
//       name: 'Japan',
//       latitude: 35.690575479040014,
//       longitude: 139.69002013079313,
//       addressOne: '',
//     },
//     {
//       continent: 'Asia',
//       name: 'Philippines',
//       latitude: 14.591845962009335,
//       longitude: 120.97810051907487,
//       addressOne: '',
//     },
//     {
//       continent: 'Asia',
//       name: 'Singapore',
//       latitude: 1.346605566574625,
//       longitude: 103.85042728467998,
//       addressOne: '',
//     },
//     {
//       continent: 'Asia',
//       name: 'Thailand',
//       latitude: 13.796574192859227,
//       longitude: 100.58778191740456,
//       addressOne: '',
//     },
//     {
//       continent: 'Asia',
//       name: 'Malaysia',
//       latitude: 3.1450184194029935,
//       longitude: 101.70158007264978,
//       addressOne: '',
//     },
//     {
//       continent: 'Asia',
//       name: 'Vietnam',
//       latitude: 21.017187882838723,
//       longitude: 105.82707387171462,
//       addressOne: '',
//     },
//     {
//       continent: 'Asia',
//       name: 'Indonesia',
//       latitude: -6.215064198067955,
//       longitude: 106.84324838228042,
//       addressOne: '',
//     },
//     {
//       continent: 'Oceania',
//       name: 'Australia',
//       latitude: -33.795928237065034,
//       longitude: 151.18178810968476,
//       addressOne: '',
//     },
//     {
//       continent: 'Oceania',
//       name: 'New Zealand',
//       latitude: -41.29473155666136,
//       longitude: 174.78103508162835,
//       addressOne: '',
//     },
//   ];

//   let svgs = [
//     {
//       selector: 'world1',
//       bounds: [
//         [84.57, -29.4],
//         [-83.6, 283],
//       ],
//     },
//     {
//       selector: 'world2',
//       bounds: [
//         [84.57, -235],
//         [-83.6, -29.4],
//       ],
//     },
//   ];
//   let containerId = 'map';
//   let listId = 'list';
//   let filterId = 'filter-buttons';
//   let $container = document.getElementById(containerId);
//   let $list = document.getElementById(listId);
//   let $filterButtonContainer = document.getElementById(filterId);
//   let filtered = false;

//   const paddingRatios = {
//     paddingVerticalRatio: 0.05,
//     paddingHorizontalRatio: 0.05,
//   };

//   let padding = setPadding($container, paddingRatios);

//   let markers = [];

//   let map = new L.Map(containerId, {
//     center: new L.LatLng(15, 19),
//     zoomControl: false,
//     doubleClickZoom: false,
//     attributionControl: false,
//     dragging: false,
//     worldCopyJump: true,
//     scrollWheelZoom: false,
//     animate: true,
//     zoomSnap: 0.25,
//     zoom: 2.25,
//   });
//   // L.tileLayer.provider('Stamen.Terrain').addTo(map);

//   svgs.forEach(function (svg) {
//     addSvgLayer(svg);
//   });

//   for (var i = 0; i < locations.length; i++) {
//     let marker = L.marker([locations[i].latitude, locations[i].longitude], {
//       icon: L.icon({
//         iconUrl:
//           'data:image/svg+xml,%3Csvg%20width%3D%2241%22%20height%3D%2241%22%20viewBox%3D%220%200%2041%2041%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle%20cx%3D%2220.5%22%20cy%3D%2220.5%22%20r%3D%2219.5%22%20fill%3D%22%236927da%22%20fill-opacity%3D%220.1%22%20%2F%3E%3Ccircle%20cx%3D%2220.5%22%20cy%3D%2220.5%22%20r%3D%2211.5%22%20fill%3D%22%236927da%22%20fill-opacity%3D%220.2%22%20%2F%3E%3Ccircle%20cx%3D%2220.5%22%20cy%3D%2220.5%22%20r%3D%223.5%22%20fill%3D%22%236927da%22%20fill-opacity%3D%221%22%20%2F%3E%3C%2Fsvg%3E',
//         iconSize: [41, 41],
//         popupAnchor: [0, -4],
//       }),
//     });
//     marker.name = locations[i].name;
//     marker.continent = locations[i].continent;
//     marker
//       .bindPopup(
//         `<h4 class="map-popup-heading">${locations[i].name}</h4>
//         <p class="map-popup-address">
//         ${locations[i].addressOne ? locations[i].addressOne : ''}
//         ${locations[i].addressTwo ? '<br>' + locations[i].addressTwo : ''}
//         ${locations[i].addressThree ? '<br>' + locations[i].addressThree : ''}
//         ${locations[i].stateProvince ? '<br>' + locations[i].stateProvince : ''}
//         ${locations[i].postCode ? '<br>' + locations[i].postCode : ''}
//         ${locations[i].country ? '<br>' + locations[i].country : ''}
//         </p>
//         <a href="mailto:test@squiz.com" class="button button-tertiary map-popup-button">
//             Get in touch
//         </a>
//         `
//       )
//       .openPopup();
//     marker.addTo(map);
//     markers.push(marker);
//   }

//   var group = new L.featureGroup(markers);
//   map.fitBounds(group.getBounds(), { padding: padding });

//   window.addEventListener('resize', function () {
//     setPadding($container, paddingRatios);
//     if (filtered) {
//       let continent = $filterButtonContainer.querySelector('.selected').value;
//       filterMarkers(markers, continent);
//     } else {
//       filterMarkers(markers);
//     }
//   });

//   initButtons($filterButtonContainer, locations);

//   // Function to add offices lists based on viewport size
//   function addOfficesListBasedOnViewport() {
//     const viewportWidth = window.innerWidth;
//     const existingElements = document.querySelectorAll('.viewport-element');
//     existingElements.forEach((element) => element.remove());

//     if (viewportWidth >= 1130) {
//       initList($list, locations);
//       $list.classList.add('map-offices__cards');
//     } else {
//       initMobileList($list, locations);
//       $list.classList.remove('map-offices__cards');
//     }
//   }

//   // Initial check when the page loads
//   addOfficesListBasedOnViewport();

//   // Update elements on window resize
//   window.addEventListener('resize', function () {
//     addOfficesListBasedOnViewport();
//     initAccordion();
//   });

//   function initButtons(el, items) {
//     let buttonsHtml = items
//       .map(function (item) {
//         return item.continent;
//       })
//       .filter(onlyUnique)
//       .map(function (continent) {
//         return `<button class="button button-secondary map__region-button continent-filter" type="button" value="${continent}">${continent}</button>`;
//       })
//       .join('');
//     el.innerHTML = buttonsHtml;
//     bindFilters(el);
//   }

//   function bindFilters(parent) {
//     let $buttons = parent.querySelectorAll('button');
//     let selected;
//     $buttons.forEach(function (button) {
//       button.addEventListener('click', function (e) {
//         if (e.target.classList.contains('selected')) {
//           e.target.classList.remove('selected');
//           showAllListItems();
//           filterMarkers(markers);
//         } else {
//           selected = parent.querySelector('.selected');
//           if (selected) {
//             selected.classList.remove('selected');
//           }
//           e.target.classList.add('selected');
//           filterListItems(e.target.value);
//           filterMarkers(markers, e.target.value);
//         }
//       });
//     });
//   }

//   function showAllListItems() {
//     let hiddenItems = $list.querySelectorAll('li.location.hide');
//     hiddenItems.forEach(function (item) {
//       item.classList.remove('hide');
//     });
//   }

//   function filterListItems(continent) {
//     let items = $list.querySelectorAll('.location');
//     let itemContinent;
//     items.forEach(function (item) {
//       itemContinent = item.getAttribute('data-continent');
//       if (itemContinent === continent) {
//         item.classList.remove('hide');
//       } else {
//         item.classList.add('hide');
//       }
//     });
//   }

//   function initList(el, items) {
//     let html = items
//       .map(function (item) {
//         return `
//           <li class="map-offices__card location"  data-continent="${item.continent}">
//             <h4 class="map-offices__card-heading">${item.name}</h4>
//             <p class="map-offices__card-address">
//               ${item.description}
//             </p>
//             <a href="#" class="button button-tertiary map-offices__card-button">
//               Get in touch
//             </a>
//           </li>
//     `;
//       })
//       .join('');
//     el.innerHTML = `<ul class="viewport-element">${html}<ul>`;
//   }

//   function initMobileList(el, items) {
//     let continents = items
//       .map(function (item) {
//         return item.continent;
//       })
//       .filter(onlyUnique);

//     let html = '';

//     continents.forEach((continent) => {
//       html += `<div class="accordion__item accordion__item-color-alt">
//                     <button class="accordion__button" aria-expanded="false">
//                     ${continent}
//                     </button>
//                     <div class="accordion__content map-offices__cards-mobile" aria-hidden="true">
//                     <ul>`;
//       const continentCountries = items.filter((item) => {
//         return item.continent === continent;
//       });

//       continentCountries.forEach((country) => {
//         html += `<li class="map-offices__card">
//         <h4 class="map-offices__card-heading">${country.name}</h4>
//         <p class="map-offices__card-address">
//             ${country.description}
//         </p>
//         <a
//           href="#"
//           class="button button-tertiary map-offices__card-button"
//         >
//           Get in touch
//         </a>
//       </li>`;
//       });

//       html += ` </ul>
//                     </div>
//                 </div>
//                 `;
//     });

//     el.innerHTML = html;
//   }

//   function filterMarkers(markers, continent) {
//     markers.forEach(function (d) {
//       if (continent) {
//         filtered = true;
//         d.filtered = d.continent !== continent;
//       } else {
//         filtered = false;
//         d.filtered = false;
//       }
//       if (d.filtered) {
//         d.setOpacity(0);
//       } else {
//         d.setOpacity(1);
//       }
//     });
//     zoomToBounds(
//       markers.filter(function (item) {
//         return !item.filtered;
//       })
//     );
//   }

//   function zoomToBounds(markers) {
//     var bounds = getMarkerBounds(markers);
//     map.fitBounds(bounds, { padding: padding, animate: true });
//   }

//   function getMarkerBounds(arr) {
//     var minLat = 180;
//     var minLng = 180;
//     var maxLat = 0;
//     var maxLng = 0;
//     var min;
//     var max;
//     arr.forEach(function (d) {
//       if (minLat > d._latlng.lat) minLat = d._latlng.lat;
//       if (minLng > d._latlng.lng) minLng = d._latlng.lng;
//       if (maxLat < d._latlng.lat) maxLat = d._latlng.lat;
//       if (maxLng < d._latlng.lng) maxLng = d._latlng.lng;
//     });
//     min = L.latLng(minLat, minLng);
//     max = L.latLng(maxLat, maxLng);
//     return L.latLngBounds(min, max);
//   }

//   function addSvgLayer(svg) {
//     var $svg = document.getElementById(svg.selector);
//     var viewBox = $svg.getAttribute('viewBox');
//     var svgElement = document.createElementNS(
//       'http://www.w3.org/2000/svg',
//       'svg'
//     );
//     svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
//     svgElement.setAttribute('viewBox', viewBox);
//     svgElement.setAttribute('preserveAspectRatio', 'none');
//     svgElement.innerHTML = $svg.innerHTML;
//     L.svgOverlay(svgElement, svg.bounds).addTo(map);
//   }

//   function setPadding(el, ratios) {
//     return [
//       ratios.paddingHorizontalRatio * el.offsetWidth,
//       ratios.paddingVerticalRatio * el.offsetHeight,
//     ];
//   }

//   function onlyUnique(value, index, self) {
//     return self.indexOf(value) === index;
//   }
// })();
